import * as moment from 'moment';
import * as _ from 'lodash';
import { Component } from 'react';
import { connect, Dispatch } from 'react-redux';
import { AppActionCreators, FollowUpDonorActionCreators, IApplicationState, IExistingDashRegistration, IExistingDonor, IFollowUpDonorLookupDataResponse, IFollowUpDonorRecordsByEmailResponse, IFollowUpDonorSaveResponse, IFollowUpDonorVerifyEmailResponse } from '@nkr/store/index';
import { IContact, IListItem } from '@nkr/models/index';
import { Alert, Button, Col, Row } from 'react-bootstrap';
import { Utility } from '@nkr/services/utility';
import { IValidationStart, IValidationConfirmMatch, IValidationDetails } from './validation';
import AddEditStart from './start';
import Details from './details';
import ConfirmMatch from './confirm-match';
import { Country } from '@nkr/enums/index';

enum Steps {
    Start = 1,
    Details = 2,
    ConfirmMatch = 3,
}

interface IProps {
    centerId: number
}

interface IStateProps {
    // app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    verifyEmail: (centerId: number, email: string) => Promise<IFollowUpDonorVerifyEmailResponse>
    getRecordsByEmail: (centerId: number, email: string) => Promise<IFollowUpDonorRecordsByEmailResponse>
    getLookupData: (centerId: number) => Promise<IFollowUpDonorLookupDataResponse>
    insert: (
        centerId: number,
        email: string,
        mrn: string,
        surveyInstanceSkip: number,
        phone: string,
        firstName: string, lastName: string,
        country: number, addressLine1: string, city: string, state: number, nonUsStateProvince: string, postalCode: string,
        gender: number,
        birthDate: string, donationDate: string,
        heightInches: number, weightLbs: number,
        registrationId: number, coordinatorContactId: number,
        hasEmail: boolean
    ) => Promise<IFollowUpDonorSaveResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    currentStep: Steps,
    stepIndex: number,

    hasEmail: number,
    coordinatorContactId: number,
    email: string,

    selectedItemType: string,
    selectedItemId: number,

    mrn: string,
    surveyInstanceSkip: number,
    phone: string,
    firstName: string,
    lastName: string,
    country: number,
    addressLine1: string,
    city: string,
    state: number,
    nonUsStateProvince: string,
    postalCode: string,
    birthDate: string,
    gender: number,
    donationDate: string,
    heightInches: number,
    heightSubFeet: number,
    heightSubInches: number,
    weightLbs: number,

    existingRegistrationsList: IExistingDashRegistration[],
    existingDonorsList: IExistingDonor[]
    validationStart: IValidationStart,
    validationConfirmMatch: IValidationConfirmMatch,
    validationDetails: IValidationDetails,
    dirty: boolean,
    errorMessage: string,
    coordinatorList: IContact[],
    countryList: IListItem[],
    stateList: IListItem[],
    genderList: IListItem[],
    followUpSurveyInstanceList: IListItem[]
}

class FollowUpDonorAddEdit extends Component<TProps, IState> {
    readonly state: IState = {
        currentStep: Steps.Start,
        stepIndex: 1,

        hasEmail: -1,
        coordinatorContactId: 0,
        email: '',

        selectedItemType: '',
        selectedItemId: 0,

        mrn: '',
        surveyInstanceSkip: -1,
        phone: '',
        firstName: '',
        lastName: '',
        country: Country.UnitedStates,
        addressLine1: '',
        city: '',
        state: null,
        nonUsStateProvince: '',
        postalCode: '',
        birthDate: '',
        gender: null,
        donationDate: '',
        heightInches: null,
        heightSubFeet: null,
        heightSubInches: null,
        weightLbs: null,

        existingRegistrationsList: [],
        existingDonorsList: [],

        validationStart: {
            hasEmail: true,
            coordinatorContactId: true,
            email: true,
            emailNotDuplicate: true
        },
        validationConfirmMatch: {
            selectedItem: true
        },
        validationDetails: {
            email: true,
            phone: true,
            country: true,
            firstName: true,
            lastName: true,
            addressLine1: true,
            city: true,
            state: true,
            nonUsStateProvince: true,
            postalCode: true,
            gender: true,
            birthDate: true,
            donationDate: true,
            heightSubFeet: true,
            weightLbs: true
        },
        dirty: false,
        errorMessage: '',
        coordinatorList: [],
        countryList: [],
        stateList: [],
        genderList: [],
        followUpSurveyInstanceList: []
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting ready, one moment please...').then(() => {
            this.props.getLookupData(this.props.centerId).then(response => {
                let { coordinatorList, countryList, stateList, genderList, followUpSurveyInstanceList } = response.data.results;

                this.setState({
                    coordinatorList,
                    countryList,
                    stateList,
                    genderList,
                    followUpSurveyInstanceList
                });

                this.props.hideLoading();
            });
        });
    }

    getIsValid = () => {
        let { validationStart, validationConfirmMatch, validationDetails } = this.state;

        if (this.state.currentStep == Steps.Start) {
            return validationStart.hasEmail && validationStart.coordinatorContactId && validationStart.email;
        }

        if (this.state.currentStep == Steps.ConfirmMatch) {
            return validationConfirmMatch.selectedItem;
        }

        if (this.state.currentStep == Steps.Details) {
            return validationDetails.email && validationDetails.phone && validationDetails.country && validationDetails.firstName
                && validationDetails.lastName && validationDetails.addressLine1 && validationDetails.city && validationDetails.state
                && validationDetails.nonUsStateProvince && validationDetails.postalCode && validationDetails.gender
                && validationDetails.birthDate && validationDetails.donationDate && validationDetails.heightSubFeet
                && validationDetails.weightLbs;
        }

        return true;
    }

    handleHasEmailChange = (hasEmail: number) => {
        this.setState({
            hasEmail
        });
    }

    handleCoordinatorContactChange = (coordinatorContactId: number) => {
        this.setState({
            coordinatorContactId
        });
    }

    handleEmailChange = (email: string) => {
        this.setState({
            email
        });
    }

    handleCancel = () => {
        window.location.href = `/center/${this.props.centerId}/follow-up/donors`;
    }

    handlePrevious = () => {
        let { currentStep, stepIndex, selectedItemType, selectedItemId } = this.state;

        if (currentStep == Steps.ConfirmMatch) {
            currentStep = Steps.Start;
            stepIndex = 1;
        }

        if (currentStep == Steps.Details && this.state.hasEmail && (this.state.existingRegistrationsList.length > 0 || this.state.existingDonorsList.length > 0)) {
            currentStep = Steps.ConfirmMatch;
            stepIndex = 2;
        }

        if (currentStep == Steps.Details) {
            currentStep = Steps.Start;
            stepIndex = 1;
        }

        if (currentStep == Steps.Start) {
            selectedItemType = '';
            selectedItemId = 0;
        }

        this.setState({
            currentStep,
            stepIndex,
            selectedItemType,
            selectedItemId
        });
    }

    handleContinue = () => {
        let {
            currentStep, hasEmail, coordinatorContactId, email,
            mrn,
            surveyInstanceSkip,
            phone, country, firstName, lastName,
            addressLine1, city, state, nonUsStateProvince,
            postalCode, gender, birthDate, donationDate,
            heightSubFeet, heightSubInches, weightLbs,
            selectedItemType, selectedItemId,
            validationStart, validationConfirmMatch, validationDetails
        } = this.state;

        let isValid = false;

        if (currentStep == Steps.Start) {
            validationStart = {
                hasEmail: hasEmail >= 0,
                coordinatorContactId: hasEmail == 0 ? coordinatorContactId > 0 : true,
                email: hasEmail == 1 ? Utility.isValidEmail(email) : true,
                emailNotDuplicate: true
            };

            isValid =
                validationStart.hasEmail
                && validationStart.coordinatorContactId
                && validationStart.email
                && validationStart.emailNotDuplicate;

            this.setState({
                validationStart,
                dirty: true
            }, async () => {
                if (isValid) {
                    await this.props.showLoading('Moving to next step, one moment please...');

                    if (this.state.hasEmail == 1) {
                        let response = await this.props.verifyEmail(this.props.centerId, this.state.email);

                        if (response.data.results.hasExistingRegistration) {
                            validationStart.email = false

                            this.setState({
                                validationStart,
                                errorMessage: response.data.results.hasExistingRegistration ? 'There is already a follow-up registration with the specified email' : ''
                            });
                        } else {
                            let response = await this.props.getRecordsByEmail(this.props.centerId, this.state.email);

                            if (response.data.success) {
                                let { existingRegistrationsList, existingDonorsList } = response.data.results;

                                if (existingRegistrationsList.length > 0 || existingDonorsList.length > 0) {
                                    this.setState({
                                        currentStep: Steps.ConfirmMatch,
                                        stepIndex: 2,
                                        existingRegistrationsList,
                                        existingDonorsList
                                    });
                                } else {
                                    this.setState({
                                        currentStep: Steps.Details,
                                        stepIndex: 2
                                    });
                                }
                            }
                        }
                    } else {
                        if (this.state.hasEmail == 0) {
                            this.setState({
                                currentStep: Steps.Details,
                                stepIndex: 2
                            });
                        }
                    }

                    this.props.hideLoading();
                }
            });
        }

        if (currentStep == Steps.ConfirmMatch) {
            validationConfirmMatch.selectedItem = this.state.selectedItemType != '' && this.state.selectedItemId > 0;

            this.setState({
                validationConfirmMatch,
                errorMessage: validationConfirmMatch.selectedItem ? '' : 'Please select at least one item from the list below to continue...'
            }, () => {
                if (this.state.validationConfirmMatch.selectedItem) {
                    if (this.state.selectedItemType == 'DASH') {
                        let reg = this.state.existingRegistrationsList.find(x => x.id == this.state.selectedItemId);

                        let { phone, firstName, lastName, country, addressLine1, city, state, nonUsStateProvince, postalCode, birthDate, donationDate, heightInches, weightLbs } = reg;
                        let countryItem = this.state.countryList.find(x => x.abbreviation == country);
                        let countryId = countryItem != null ? countryItem.id : 0;

                        let stateItem = this.state.stateList.find(x => x.abbreviation == state);
                        let stateId = stateItem != null ? stateItem.id : 0;

                        let heightSubFeet = Math.floor(heightInches / 12);
                        let heightSubInches = heightInches % 12;

                        birthDate = moment(birthDate, 'MM/DD/YYYY').format('YYYY-MM-DD');
                        donationDate = donationDate != '' ? moment(donationDate, 'MM/DD/YYYY').format('YYYY-MM-DD') : '';

                        this.setState({
                            currentStep: Steps.Details,
                            stepIndex: 3,
                            phone, firstName, lastName, country: countryId, addressLine1, city, state: stateId, nonUsStateProvince, postalCode,
                            birthDate, donationDate, heightInches, heightSubFeet, heightSubInches, weightLbs
                        });
                    } else {
                        let donor = this.state.existingDonorsList.find(x => x.id == this.state.selectedItemId);

                        let { phone, firstName, lastName, addressLine1, city, state, postalCode, birthDate, donationDate, heightInches, weightLbs } = donor;

                        let stateItem = this.state.stateList.find(x => x.abbreviation == state);
                        let stateId = stateItem != null ? stateItem.id : 0;

                        let country = 0;

                        if (stateId > 0) {
                            country = Country.UnitedStates;
                        }

                        let heightSubFeet = Math.floor(heightInches / 12);
                        let heightSubInches = heightInches % 12;

                        birthDate = moment(birthDate, 'MM/DD/YYYY').format('YYYY-MM-DD');
                        donationDate = donationDate != '' ? moment(donationDate, 'MM/DD/YYYY').format('YYYY-MM-DD') : '';

                        this.setState({
                            currentStep: Steps.Details,
                            stepIndex: 3,
                            phone, firstName, lastName, country, addressLine1, city, state: stateId, postalCode,
                            birthDate, donationDate, heightInches, heightSubFeet, heightSubInches, weightLbs
                        });
                    }
                }
            });
        }

        if (currentStep == Steps.Details) {

            let birthDateValid = true;

            birthDateValid = moment(birthDate).isValid();

            let today = moment();
            let age = today.diff(birthDate, 'years');
            if (age < 18 || age > 100) {
                birthDateValid = false;
            }


            validationDetails = {
                email: hasEmail ? Utility.isValidEmail(email) : true,
                phone: phone != '',
                country: country >= 0,
                firstName: firstName != '',
                lastName: lastName != '',
                addressLine1: addressLine1 != '',
                city: city != '',
                state: state > 0,
                nonUsStateProvince: country == Country.Other ? nonUsStateProvince != '' : true,
                postalCode: postalCode != '',
                gender: gender > 0,
                birthDate: birthDateValid,
                donationDate: moment(donationDate, 'YYYY-MM-DD').isValid(),
                heightSubFeet: heightSubFeet > 0,
                weightLbs: Utility.isNumber(weightLbs)
            };

            isValid =
                validationDetails.email && validationDetails.phone && validationDetails.country && validationDetails.firstName
                && validationDetails.lastName && validationDetails.addressLine1 && validationDetails.city && validationDetails.state
                && validationDetails.nonUsStateProvince && validationDetails.postalCode && validationDetails.gender
                && validationDetails.birthDate && validationDetails.donationDate && validationDetails.heightSubFeet
                && validationDetails.weightLbs

            this.setState({
                validationDetails,
                dirty: true
            }, () => {
                let heightInches = (heightSubFeet * 12) + heightSubInches;
                let registrationId = selectedItemType == 'DASH' ? selectedItemId : 0;

                this.setState({
                    errorMessage: !isValid && !validationDetails.birthDate && this.state.birthDate.length > 0 ? 'Birth date must be between 18 and 100 years ago' : ''
                });

                if (isValid) {
                    this.props.showLoading('Saving donor follow-up, one moment please...').then(async () => {
                        let response = await this.props.insert(
                            this.props.centerId,
                            email,
                            mrn,
                            surveyInstanceSkip,
                            phone, firstName, lastName, country,
                            addressLine1, city, state, nonUsStateProvince,
                            postalCode, gender, birthDate, donationDate,
                            heightInches,
                            weightLbs, registrationId, coordinatorContactId,
                            hasEmail == 1);

                        this.props.hideLoading();

                        if (response.data.success) {
                            window.location.href = `/center/${this.props.centerId}/follow-up/donor/${response.data.results}`;
                        }
                    });
                } else {
                    window.scroll(0, 0);
                }
            });
        }
    }

    handleConfirmMatch = (selectedItemType: string, selectedItemId: number) => {
        this.setState({
            selectedItemType,
            selectedItemId
        });
    }

    handleFieldChange = (field: string, value: any) => {
        let selectFields = ['surveyInstanceSkip', 'country', 'state', 'gender', 'heightSubFeet', 'heightSubInches', 'coordinatorContactId'];
        let isSelectField = selectFields.indexOf(field) >= 0;
        let state = _.cloneDeep(this.state);

        if (isSelectField) {
            state[field] = parseInt(value);
        } else {
            state[field] = value;
        }

        if (field == 'coordinatorContactId') {
            if (parseInt(value) > 0) {
                state.email = '';
            }
        }

        this.setState(state);
    }

    render = () => {
        const isValid = this.getIsValid();

        return (
            <div style={{ minHeight: 500 }}>
                <Row>
                    <Col xs={12} lg={8} lgOffset={2}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 20, marginBottom: '1.2em' }}>
                            <h1 style={{ margin: 0 }}>Add Donor for Follow-Up</h1>
                            <Button bsStyle='link' onClick={this.handleCancel}>Return to Donor List</Button>
                        </div>
                    </Col>
                </Row>

                {!isValid && (
                    <Row>
                        <Col xs={12} lg={8} lgOffset={2}>
                            <Alert bsStyle='danger'>
                                {this.state.errorMessage == '' ?
                                    <span>The items in red are required to continue...</span>
                                    :
                                    <span>{this.state.errorMessage}</span>
                                }
                            </Alert>
                        </Col>
                    </Row>
                )}

                {this.state.currentStep == Steps.Start && (
                    <AddEditStart
                        hasEmail={this.state.hasEmail}
                        coordinatorContactId={this.state.coordinatorContactId}
                        email={this.state.email}
                        dirty={this.state.dirty}
                        validation={this.state.validationStart}
                        coordinatorList={this.state.coordinatorList}
                        onHasEmailChange={this.handleHasEmailChange}
                        onCoordinatorContactChange={this.handleCoordinatorContactChange}
                        onEmailChange={this.handleEmailChange}
                        onContinue={this.handleContinue}
                    />
                )}

                {this.state.currentStep == Steps.ConfirmMatch && (
                    <ConfirmMatch
                        step={this.state.stepIndex}
                        selectedItemType={this.state.selectedItemType}
                        selectedItemId={this.state.selectedItemId}
                        existingRegistrations={this.state.existingRegistrationsList}
                        existingDonors={this.state.existingDonorsList}
                        dirty={this.state.dirty}
                        validation={this.state.validationConfirmMatch}
                        onConfirmMatch={this.handleConfirmMatch}
                        onPrevious={this.handlePrevious}
                        onContinue={this.handleContinue}
                    />
                )}

                {this.state.currentStep == Steps.Details && (
                    <Details
                        step={this.state.stepIndex}
                        mrn={this.state.mrn}
                        email={this.state.email}
                        surveyInstanceSkip={this.state.surveyInstanceSkip}
                        phone={this.state.phone}
                        firstName={this.state.firstName}
                        lastName={this.state.lastName}
                        country={this.state.country}
                        addressLine1={this.state.addressLine1}
                        city={this.state.city}
                        state={this.state.state}
                        nonUsStateProvince={this.state.nonUsStateProvince}
                        postalCode={this.state.postalCode}
                        birthDate={this.state.birthDate}
                        gender={this.state.gender}
                        donationDate={this.state.donationDate}
                        heightSubFeet={this.state.heightSubFeet}
                        heightSubInches={this.state.heightSubInches}
                        weightLbs={this.state.weightLbs}
                        coordinatorContactId={this.state.coordinatorContactId}
                        dirty={this.state.dirty}
                        validation={this.state.validationDetails}
                        coordinatorList={this.state.coordinatorList}
                        countryList={this.state.countryList}
                        stateList={this.state.stateList}
                        genderList={this.state.genderList}
                        followUpSurveyInstanceList={this.state.followUpSurveyInstanceList}
                        onFieldChange={this.handleFieldChange}
                        onPrevious={this.handlePrevious}
                        onSave={this.handleContinue}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getLookupData: (centerId) => {
            return dispatch(FollowUpDonorActionCreators.getLookupData(centerId));
        },
        verifyEmail: (centerId, email) => {
            return dispatch(FollowUpDonorActionCreators.verifyEmail(centerId, email));
        },
        getRecordsByEmail: (centerId, email) => {
            return dispatch(FollowUpDonorActionCreators.getRecordsByEmail(centerId, email));
        },
        insert: (
            centerId,
            email,
            mrn,
            surveyInstanceSkip,
            phone,
            firstName, lastName,
            country, addressLine1, city, state, nonUsStateProvince, postalCode,
            gender,
            birthDate, donationDate,
            heightInches, weightLbs,
            registrationId, coordinatorContactId,
            hasEmail
        ) => {
            return dispatch(FollowUpDonorActionCreators.insert(
                centerId,
                email,
                mrn,
                surveyInstanceSkip,
                phone,
                firstName, lastName,
                country, addressLine1, city, state, nonUsStateProvince, postalCode,
                gender,
                birthDate, donationDate,
                heightInches, weightLbs,
                registrationId, coordinatorContactId,
                hasEmail));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(FollowUpDonorAddEdit);